import { render, staticRenderFns } from "./hqglLogisticsFixAttachDetail.vue?vue&type=template&id=5065027a&scoped=true&"
import script from "./hqglLogisticsFixAttachDetail.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsFixAttachDetail.vue?vue&type=script&lang=js&"
import style0 from "./hqglLogisticsFixAttachDetail.vue?vue&type=style&index=0&id=5065027a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065027a",
  null
  
)

export default component.exports